import { SchemaCRUD } from '@/components/crud/SchemaCRUD';

const Requests = () => {
	return (
		<SchemaCRUD
			entity="requests"
			title="Solicitações de Papéis"
			description="Gerenciar solicitações de papéis de usuários"
			apiEndpoint="v1/requests"
		/>
	);
};

export default Requests;
